module.exports = __webpack_public_path__ + "static/img/5.89ea2fd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Empresarial-Fraude-Empleados/5.png
// module id = VppH
// module chunks = 0